import { render } from "./MatrixCaseDiscussion.vue?vue&type=template&id=86724490&scoped=true"
import script from "./MatrixCaseDiscussion.vue?vue&type=script&lang=js"
export * from "./MatrixCaseDiscussion.vue?vue&type=script&lang=js"

import "./MatrixCaseDiscussion.vue?vue&type=style&index=0&id=86724490&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86724490"]])

export default __exports__